module.exports = __webpack_public_path__ + "img/jsfnd2.35eccaa7.png";